import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountType } from '@mnz-core/models/_enums';
import { formUtils } from '@mnz-shared/shared.constants';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export const createLoginForm = (
  formBuilder: FormBuilder,
  accountType$: Observable<AccountType>
): Observable<FormGroup> => {
  return accountType$.pipe(
    map((account) => {
      const { validators } = formUtils;

      const usernameValidator =
        account === AccountType.CARD_HOLDER
          ? validators.email
          : ({ value }: AbstractControl) => {
              const symbols = `@\`'"\\`;
              return symbols.split('').some((symbol) => value && value.includes(symbol)) ? { credential: true } : null;
            };

      return formBuilder.group({
        credential: [String(), Validators.compose([Validators.required, usernameValidator, Validators.maxLength(60)])],
        password: [String(), Validators.required]
      });
    }),
    shareReplay()
  );
};

export const createEmailForm = (formBuilder: FormBuilder): FormGroup => {
  return formBuilder.group({
    email: [String(), Validators.compose([Validators.required, Validators.email, Validators.maxLength(60)])],
  });
};
